var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"renotification-tooltip"},[_c('p',[_vm._v("Nombre de renotification total : "+_vm._s(_vm.state.count))]),_c('p',[_vm._v("Date de dernière renotification : "+_vm._s(_vm.lastRenotifiedAt))]),(_vm.state.blockedReason)?_c('p',{staticClass:"renotification-tooltip__reason"},[_vm._v(_vm._s(_vm.state.blockedReason))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }